const PAID_STATUSES = new Set(['PAID', 'AUTHORIZED', 'CONFIRMED', 'RECEIVED']);
const REFUNDED_STATUSES = new Set(['REFUNDED']);
const EXPIRED_STATUSES = new Set(['OVERDUE', 'CANCELLED', 'DELETED', 'EXPIRED']);
const PAID_RELEASE_STATUSES = new Set(['PAGO', 'PENDENTE_LIBERACAO', 'LIBERADO', 'PROCESSANDO', 'TRANSFERIDO']);

const normalized = (value) => String(value || '').trim().toUpperCase();

const paymentState = ({ status, paymentStatus, releaseStatus } = {}) => {
  const external = normalized(status);
  const stored = normalized(paymentStatus);
  const release = normalized(releaseStatus);

  if (REFUNDED_STATUSES.has(external) || stored === 'REFUNDED') return 'refunded';
  if (EXPIRED_STATUSES.has(external) || release === 'EXPIRADO') return 'expired';
  if (PAID_STATUSES.has(external) || stored === 'PAID' || PAID_RELEASE_STATUSES.has(release)) return 'paid';
  return 'pending';
};

const isTerminalPaymentState = (state) => ['paid', 'refunded', 'expired'].includes(state);

const withoutReusablePix = (payment, updates = {}) => ({
  ...(payment || {}),
  ...updates,
  pixCode: null,
  pixQrCodeBase64: null,
  pixQrCodeUrl: null,
  paymentUrl: null,
  pixExpiresAt: null,
});

export { isTerminalPaymentState, paymentState, withoutReusablePix };
